<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
      <div class="card">        
        <div class="card-body">
          <div class="row">
              <div  class="col-lg-3 col-sm-6 col-12">
                  <!-- Show Supplier Name in the first form -->
                <div class="form-group">
                  <label>Supplier Name</label>
                  <model-list-select
                    :list="vendorListFromApi"
                    v-model="forms[0].vendor"
                    option-value="vendorid"
                    option-text="vendorname"
                    placeholder="Select Supplier"
                    
                  ></model-list-select>
                </div>
              </div>
              <div  class="col-lg-3 col-sm-6 col-12">
                  <!-- Show Invoice Date in the first form -->
                <div class="form-group">
                  <label>Invoice Date</label>
                  <b-form-input
                    type="date"
                    v-model="forms[0].invoicedate"
                    placeholder="Select invoice date"
                    
                  ></b-form-input>
                </div>
              </div>
            </div>
          <div
            v-for="(form, index) in forms"
            :key="index"
            ref="formRefs"
            :class="{ 'additional-form': index > 0 }"
          >
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Item Name</label>
                  <model-list-select
                    :list="itemListFromApi"
                    v-model="form.purchaseitem"
                    option-value="itemid"
                    option-text="itemname"
                    placeholder="Select item"
                    :ref="`purchaseitemInput${index}`"
                    tabindex="1"
                    autofocus
                    
                  ></model-list-select>
                </div>
              </div>
              <div class="col-lg-2 col-sm-6 col-12">
                <div class="form-group">
                  <label>Quantity</label>
                  <b-form-input
                    type="number"
                    v-model.number="form.quantity"
                    @input="validateQuantity(form)"
                    min="0"
                    max="999999.99"
                      
                  ></b-form-input>
                </div>
              </div>

              <div class="col-lg-2 col-sm-6 col-12">
                <div class="form-group">
                  <label>Unit Price</label>
                  <span
                      data-bs-placement="top"
                      title="Enter the Unit Price or Press the 'Enter' key to add another item">
                  <b-form-input
                    type="number"
                    v-model.number="form.unitprice"
                    @input="validateUnitprice(form)"
                    @keypress.enter="addForm()"
                  ></b-form-input>
                </span>
                </div>
              </div>

              <div class="col-lg-2 col-sm-6 col-12">
                <div class="form-group">
                  <label>Total Price</label>
                  <b-form-input
                    type="number"
                    v-model.number="form.totalprice"
                    :disabled="true"
                    @keypress.enter="submitForm()"
                  ></b-form-input>
                </div>
              </div><span
                  v-if="index > 0"
                  @click="removeForm(index)"
                  class="col-md-1 col-lg-1 col-sm-2 desktop tt"
                  data-bs-placement="top"
                  title="Remove"
                  ><img
                    src="../../../assets/img/icons/x.svg"
                    alt="close"
                    class="hover-darken"
                />
              </span> 
            </div>             
            
              <hr style="border-top: 4px solid #000; margin: 10px 0" />
          </div>
          <div class="row">
            <span
              @click="addForm"
              class="col-md-2 col-sm-2 d-flex align-items-center mb-4 hover-darken tt"
              data-bs-placement="top"
              title="Add"
            >
              <img
                src="../../../assets/img/icons/plus-circle.svg"
                alt="close"
                class="mx-1"
              />
              Add Item</span
            >
          </div>
          <!-- <button @click="addForm" class="btn btn-success me-2">Add More</button> -->
          <button @click="submitForms" class="btn btn-primary me-2">Submit All</button>
          <router-link to="purchaselist" class="btn btn-secondary">Cancel</router-link>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelListSelect } from "vue-search-select"
import moment from "moment";
import axios from "axios";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';

export default {
  components: {
    ModelListSelect,
  },
  name: "addpurchase",
  data() {
    const today = new Date();

    return {
      title: "Add Purchase Item",
      title1: "Create new purchase",
      forms: [
        {
          purchaseitem: '',
          invoicedate: `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`,
          vendor: null, 
          quantity: 0, 
          unitprice: 0, 
          totalprice: 0, 
        },
      ],
      itemListFromApi: [],
      vendorListFromApi: [],
    };
  },
  created() {
    this.fetchItemListFromApi();
    this.fetchVendorListFromApi();
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
    
    this.$nextTick(() => this.$refs[`purchaseitemInput0`][0].$el.focus());
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  computed:{
    ...mapGetters(['getCurrentLocation']),

    currentLocation() { return this.getCurrentLocation; },
    
    locationName() {
      const loc = this.currentLocation;
      return loc ? Object.keys(loc) : null;
    },
    locationId() {
      const loc = this.currentLocation;
      return loc ? loc.id: null;
    },
  },
  methods: {
    handleKeydown(event) {
      if (this.$route.path === '/addpurchase' && event.ctrlKey && (event.key === 'm' || event.key === 'M')) {
        event.preventDefault();
        this.addForm();
      }
    },
    validateQuantity(form) {
      const quantity = parseFloat(form.quantity);
      if (quantity < 0) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid Quantity',
          text: 'Quantity must be a positive number.',
        });
        form.quantity = Math.max(quantity, 0);
      }
      this.calculateTotalOnChange(form);
    },
    validateUnitprice(form) {
      const unitprice = parseFloat(form.unitprice);
      if (unitprice < 0) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid Unitprice',
          text: 'Unitprice must be a positive number.',
        });
        form.unitprice = Math.max(unitprice, 0);
      }
      this.calculateTotalOnChange(form);
    },
    calculateTotalOnChange(form) {
    // Calculate total price based on quantity and unit price
      const unitPrice = parseFloat(form.unitprice) || 0;
      const quantity = parseFloat(form.quantity) || 0;
      
      
      form.totalprice = (unitPrice * quantity).toFixed(2);
    },
    addForm() {
      if (this.forms.length < 20) {
        this.forms.push({
          purchaseitem: '',
          quantity: 0,
          unitprice: 0,
          totalprice: 0,
          
        });
        this.$nextTick(() => {
          const newIndex = this.forms.length - 1;
          
          this.$refs[`purchaseitemInput${newIndex}`][0].$el.focus();
        });
      } else {
        Swal.fire("You can add a maximum of 20 forms.");
      }
    },
    removeForm(index) {
      this.forms.splice(index, 1);
    },
    
    async fetchItemListFromApi() {
      try {
        const response = await axios.get(`/v1/items?locationid=${this.locationId}`);
        this.itemListFromApi = response.data;
      } catch (error) {
        console.error('Error fetching item list:', error);
      }
    },

    async fetchVendorListFromApi() {
      try {
        const response = await axios.get(`/v1/vendors?locationid=${this.locationId}`);
        this.vendorListFromApi = response.data;
      } catch (error) {
        console.error('Error fetching vendor list:', error);
      }
    },
    //API call
    postData(forms) {
      axios.post('/v1/purchases', forms)
        .then(response => {
          Swal.fire("Purchase created successfully");
          this.$router.push({ path: '/purchaselist' });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(error.response.data.detail);
        });
    },

    async submitForms() {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
        const firstForm = this.forms[0];
        
        
        const formattedInvoiceDateTime = moment(firstForm.invoicedate).format("YYYY-MM-DDT") + moment().format("HH:mm:ss");
        
        const currentPurchaseDateTime = moment().format("YYYY-MM-DDTHH:mm:ss");

        const allFormData = this.forms.map(form => ({
          purchaseitem: form.purchaseitem,
          
          invoicedate: formattedInvoiceDateTime,
          vendor: firstForm.vendor,
          locationid:this.locationId,
          quantity: form.quantity,
          unitprice: form.unitprice,
          totalprice: form.totalprice,
          
          purchasedate: currentPurchaseDateTime, 
        }));
        
        this.postData(allFormData);
      }
    },
    
    submitForm() {
      this.submitForms();
    },
  },
};
</script>